(function () {
  if (window.customElements && customElements.get('frm-bundle-upsell')) return;

  class FrmBundleUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleChange);
      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this.syncQuantity(checked);
    }

    handleChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
      this.syncQuantity(target);
    };

    syncQuantity(radio) {
      const qty = parseInt(radio.value, 10);
      if (!Number.isFinite(qty) || qty < 1) return;

      const formId = this.dataset.formId;
      const byId = formId ? document.getElementById(formId + '-quantity') : null;
      const scope = this.closest('.shopify-section') || document;
      const qtyInput = byId || scope.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      const current = parseInt(qtyInput.value, 10);
      if (current === qty) return;

      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('frm-bundle-upsell', FrmBundleUpsell);
})();
